import store from '@/state/store';
import { resetPassword } from '@/api/auth';
import authenticationSlice from '@/state/authentication.slice';
import { ClaimAndPasswordRequest } from '@bimdata/definitions/dto/claim-and-password-request.dto';
import { handleError } from '../common';

export default async (body: ClaimAndPasswordRequest) => {
  try {
    await resetPassword(body);
    store.dispatch(authenticationSlice.actions.finishPasswordReset());
  } catch (error) {
    handleError(error);
    throw error;
  }
};